import React from "react";
import PropTypes from "prop-types";

const TableSkeleton = ({ rows, columns, showCheckbox, showExpandIcon }) => {
  const totalColumns = columns + (showCheckbox ? 1 : 0) + (showExpandIcon ? 1 : 0);

  const cellStyle = {
    padding: "12px 16px",
  };

  const barStyle = {
    height: 10,
    backgroundColor: "#F1F3F5",
    borderRadius: 4,
    width: "100%",
  };

  return (
    <div style={{ padding: "12px 0" }}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${totalColumns}, minmax(0, 1fr))`,
            alignItems: "center",
            gap: 8,
            padding: "8px 0",
          }}
        >
          {Array.from({ length: totalColumns }).map((__, colIndex) => (
            <div key={colIndex} style={cellStyle}>
              <div style={barStyle} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

TableSkeleton.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number.isRequired,
  showCheckbox: PropTypes.bool,
  showExpandIcon: PropTypes.bool,
};

TableSkeleton.defaultProps = {
  rows: 10,
  showCheckbox: false,
  showExpandIcon: false,
};

export default TableSkeleton;
